
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import { AuthStoreModule } from "@/modules/auth/store/auth.store";
import AppIcon from "./AppIcon.vue";
import AppButton from "./AppButton.vue";
import AppLogotype from "./AppLogotype.vue";
import AppHamburger from "./AppHamburger.vue";
import AppNavbarProfile from "./AppNavbarProfile.vue";

@Component({
  components: { AppIcon, AppLogotype, AppButton, AppHamburger, AppNavbarProfile },
})
export default class AppNavbar extends Vue {
  @Prop()
  public readonly miniSidebar!: boolean;

  @Emit()
  public onToggleMiniSidebar(): void {}

  public async logout(): Promise<void> {
    try {
      await AuthStoreModule.logout();
      await this.$router.replace({
        name: "AuthLogin",
      });
      this.$notify({
        type: "success",
        text: "You was successfully logged out",
      });
    } catch {}
  }
}
